import { render, staticRenderFns } from "./ProvidersList.vue?vue&type=template&id=e6c386c0&scoped=true&"
import script from "./ProvidersList.vue?vue&type=script&lang=js&"
export * from "./ProvidersList.vue?vue&type=script&lang=js&"
import style0 from "./ProvidersList.vue?vue&type=style&index=0&id=e6c386c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c386c0",
  null
  
)

export default component.exports